import React, { useCallback, useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import i18n from 'i18next';
import { themeColor } from '../Theming';
import timColors from '../Theming/TIMTheme/colors';
import { usePageViewTracking, useQuery } from '../Common/Hooks';
import CashSaverBrands from './Components/CashSaverBrands';
import images from '../Theming/images';
import {
  ANALYTICS_PAGE_NAMES,
  trackClickedActionEvent,
} from '../Common/Analytics/utils';
import env from '../env';

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 25px;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  width: 343px;
`;

const LinkText = styled.a`
  color: ${themeColor('blue')};
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MultiStepStyledButton = styled.button`
  flex-shrink: 0;
  color: white;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  background-color: ${timColors.cloudBlue};
  width: 343px;
  height: 52px;
  border-width: 0px;
  font-family: TIMSans-Regular;
`;

const CashSaverBrandsContainer = styled.div`
  width: 100%;
  padding-bottom: 0px;
  overflow-x: scroll; /* Enables horizontal scrolling */
  overflow-y: hidden;
`;

interface Props {
  platform?: 'android' | 'ios';
}

interface AndroidInterface {
  close(): void;
}

declare const KindredAndroid: AndroidInterface | undefined;

const PartnerNewPluginActivateTimMultiStepAllDone: React.FC<Props> = ({
  platform = 'ios',
}) => {
  usePageViewTracking(ANALYTICS_PAGE_NAMES.activation_complete_page, 'TIM');
  if (i18n.language != 'it') {
    i18n.changeLanguage('it');
  }
  const { t } = useTranslation();
  const query = useQuery();

  const openApp = useCallback(() => {
    trackClickedActionEvent(
      query,
      'TIM',
      'back_to_app',
      ANALYTICS_PAGE_NAMES.activation_complete_page
    );

    if (platform === 'ios') {
      if (env.tim_app_scheme) {
        window.location = env.tim_app_scheme as (string | Location) & Location;
      }
    } else {
      if (typeof KindredAndroid !== 'undefined' && KindredAndroid.close) {
        KindredAndroid.close();
      }
    }
  }, [query]);

  return (
    <MultiStepActivationContainer
      bodyMarginTop={10}
      headerText={'PartnerNewpluginsdkActivate.timActivationSuccessTitle'}
      subHeaderText={
        'PartnerNewpluginsdkActivate.timActivationSuccessSubTitle' + platform
      }
      successPageView
      logo={images.tim_ios_success_icon?.default}
    >
      <BodyContentContainer>
        <CashSaverBrandsContainer>
          <CashSaverBrands noPaddingTop={true} />
        </CashSaverBrandsContainer>
        <SubTitleTextContainer>
          <SubTitleText>
            <Trans
              t={t}
              i18nKey={
                'PartnerNewpluginsdkActivate.timActivationSuccessReturnToTim'
              }
            >
              <LinkText>AbsoluteText</LinkText>
            </Trans>
          </SubTitleText>
        </SubTitleTextContainer>
        <MultiStepStyledButton onClick={openApp}>
          {t('PartnerNewpluginsdkActivate.timActivationSuccessBackToApp')}
        </MultiStepStyledButton>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerNewPluginActivateTimMultiStepAllDone;
